import { useTranslation } from 'react-i18next';
import { BA_COVERAGE } from './baCoverageSpec';
import { BaMatrixRow } from './BaMatrixRow';
import type { IBaModuleMatrixProps } from './IBaModuleMatrixProps';

/**
 * Матриця «Модулі × аналіз» (прототип v4): картка з прокруткою, липка шапка (Модуль · шість видів · Виконані вимоги · Покриття), рядки
 * модулів; без рядків (режим «З прогалинами», усе покрито) — «Кожен модуль повністю покрито.» зеленим.
 */
export function BaModuleMatrix({ rows, nameOf, categoryOf, onOpenModule, onOpenCell }: IBaModuleMatrixProps) {
  const { t } = useTranslation();
  return (
    <div className="ba-table">
      <div className="ba-grid ba-thead">
        <span>{t('modBody.ba.module')}</span>
        {BA_COVERAGE.matrixKinds.map((kind) => {
          const label = t(`modBody.ba.cols.${kind}`, { defaultValue: kind });
          return <span key={kind} className="ba-thead__col" title={label}>{label}</span>;
        })}
        <span className="ba-thead__done">{t('modBody.ba.done')}</span>
        <span className="ba-thead__cov">{t('modBody.ba.coverage')}</span>
      </div>
      {rows.map((row) => (
        <BaMatrixRow key={row.value} row={row} name={nameOf(row.value)} category={categoryOf(row.category)} onOpen={() => onOpenModule(row.value)}
          onCell={(kind) => onOpenCell(kind, row.value)} />
      ))}
      {!rows.length && <div className="ba-none">{t('modBody.ba.allCovered')}</div>}
    </div>
  );
}
